module.exports = __webpack_public_path__ + "@/assets/img/shield-user.fff73466.svg";